import { useLocale } from '@repo/i18n/react';
import { cn } from '@repo/ui/lib/utils';
import { useEffect, useRef } from 'react';
import { AboutUsSection } from './components/about-us-section';
import { AgentsAnimationSection } from './components/agents-animation-section';
import { ContactSection } from './components/contact-section';
import { CTASection } from './components/cta-section';
import { CustomerReviewsSection } from './components/customer-reviews-section';
import { HeroSection } from './components/hero-section';
import { LandingFooter } from './components/landing-footer';
import { LandingNav } from './components/landing-nav';
import { RavenApiSection } from './components/raven-api-section';
import { RavenApiWorkflowSection } from './components/raven-api-workflow-section';
import { ReportBuildSection } from './components/report-build-section';
import { TeamCollaborationSection } from './components/team-collaboration-section';
import { WhoIsRavenForSection } from './components/who-Is-raven-for-section';

export const HomePage = () => {
  useLocale();

  const scrollRef = useRef<HTMLDivElement>(null);

  // The global CSS sets overflow-hidden on html/body/#root for the app shell.
  // The landing page is a standalone scrollable container instead.
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.classList.add('landing-root-fix');
    return () => {
      if (root) root.classList.remove('landing-root-fix');
    };
  }, []);

  // Smooth-scroll anchor handler so nav links work inside the container
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href^='#']") as HTMLAnchorElement | null;
      if (!anchor) return;
      const id = anchor.getAttribute('href')?.slice(1);
      if (!id) return;
      const el = container.querySelector(`#${id}`);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });
      }
    };

    container.addEventListener('click', handleAnchorClick);
    return () => container.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <div
      className={cn(
        'landing-scroll-container mx-auto h-full w-full overflow-y-auto overflow-x-hidden scroll-smooth bg-landing-bg font-sans',
        'force-light',
      )}
      ref={scrollRef}
    >
      <LandingNav />
      <main className="max-w-screen">
        <HeroSection className="px-6 py-24 lg:px-10" />
        {/* <OurSolutionSection className="px-6 py-24 lg:px-10" /> */}
        {/* <ComplianceInsightsSection className="px-6 py-24 lg:px-10" /> */}
        <ReportBuildSection className="px-6 py-24 lg:px-10" />
        {/* <RavenAgentsSection className="px-6 py-24 lg:px-10" /> */}
        <AgentsAnimationSection />
        <TeamCollaborationSection className="px-6 py-24 lg:px-10" />
        <RavenApiSection className="bg-[#1B1B32] py-24" />
        <RavenApiWorkflowSection className="bg-[#1B1B32] py-24" />
        <WhoIsRavenForSection className="px-6 py-24 lg:px-10" />
        <AboutUsSection className="px-6 py-24 lg:px-10" />
        <ContactSection className="px-6 py-24 lg:px-10" />
        <CustomerReviewsSection className="px-6 py-24 lg:px-10" />
        <CTASection className="px-6 py-24 lg:px-10" />
      </main>
      <LandingFooter />
    </div>
  );
};
